// Occupation id → simulator, for pages outside the simulator (the profession
// page) that only need to know a simulator exists. Importing `packs` there
// would ship every pack's full content; a test keeps this in sync with packs.
import { getLanguage } from 'translation';

const catalog = {
  '66b280672a4e4285b87ebca8': {
    id: 'project-manager',
    minutes: 10,
    tagline: {
      en: 'Three teams, one slipping deadline and a client who wants a demo on Thursday',
      ua: 'Три команди, дедлайн, що сповзає, і клієнт, який хоче демо в четвер'
    }
  },
  '683b01059a1e027695ece656': {
    id: 'recruiter',
    minutes: 10,
    tagline: {
      en: 'Four open roles, one impatient engineering lead and a candidate who changes his mind',
      ua: 'Чотири відкриті вакансії, нетерплячий керівник розробки і кандидат, який передумав'
    }
  },
  '683b01059a1e027695ece64e': {
    id: 'sales-manager',
    minutes: 10,
    tagline: {
      en: 'Nine days to quarter-end, a buyer with a cheaper quote and a director who wants a number by five',
      ua: 'Дев’ять днів до кінця кварталу, закупівельник із дешевшою пропозицією і директорка, якій потрібна цифра до п’ятої'
    }
  },
  '66b280672a4e4285b87eb995': {
    id: 'marketing-manager',
    minutes: 10,
    tagline: {
      en: 'Two days to launch, one budget, a founder who wants a viral video and a review that is spreading',
      ua: 'Два дні до запуску, один бюджет, засновниця, яка хоче вірусне відео, і відгук, що розлітається'
    }
  },
  '66b280672a4e4285b87eb56b': {
    id: 'data-analyst',
    minutes: 10,
    tagline: {
      en: 'Orders fell over the weekend and five people already know why. Find out who is right.',
      ua: 'Замовлення за вихідні впали, і п’ятеро вже знають чому. З’ясуй, хто правий.'
    }
  },
  '683b01059a1e027695ece8a0': {
    id: 'qa-engineer',
    minutes: 10,
    tagline: {
      en: 'Release day, 200 tests, five open bugs and a developer who says it works on his machine',
      ua: 'День релізу, 200 тестів, п’ять відкритих багів і розробник, у якого «все працює»'
    }
  },
  '683b01059a1e027695ece66e': {
    id: 'customer-support',
    minutes: 10,
    tagline: {
      en: 'A fibre cut, an exam in forty minutes and a customer who wants the whole month back',
      ua: 'Обрив оптики, іспит за сорок хвилин і клієнтка, яка хоче повернути гроші за весь місяць'
    }
  },
  '66b280662a4e4285b87eb0d6': {
    id: 'accountant',
    minutes: 10,
    tagline: {
      en: 'VAT week, wages on Wednesday, a director with "two small things" and 48 000 from nowhere',
      ua: 'Тиждень ПДВ, зарплата в середу, директор із «двома дрібницями» і 48 000 нізвідки'
    }
  },
  '66b280672a4e4285b87ebad7': {
    id: 'nurse',
    minutes: 11,
    tagline: {
      en: 'Eighteen patients, one doctor stuck in the ER and a medication chart that does not add up',
      ua: 'Вісімнадцять пацієнтів, один лікар, що застряг у приймальному, і лист призначень, який не сходиться'
    }
  },
  '66b280672a4e4285b87ebf1d': {
    id: 'teacher',
    minutes: 10,
    tagline: {
      en: "Five lessons, a parents' chat on fire and a student who does not want to go home",
      ua: 'П’ять уроків, батьківський чат, що палає, і учениця, яка не хоче йти додому'
    }
  }
};

// Packs are written in en/ua only, so other locales neither advertise nor
// index them (they would be English duplicates).
const LANGS = ['ua', 'en'];

export const hasSimulatorContent = () => LANGS.includes(getLanguage());

export const getSimulator = (occupationId) =>
  (hasSimulatorContent() && occupationId && catalog[occupationId]) || null;

export default catalog;
